import axios from 'axios'
import { showSuccess, showError } from '../../index.js'

export default {
  namespaced: true,
  state () {
    return {
      fileName: '',
      media: [],
      mediaCategories: []
    }
  },
  getters: {
    backendMediaCategoriesWithoutPage (state) {
      return state.mediaCategories.filter(item => item.lang === 'all')
    },
    backendMediaWithoutPage (state) {
      return state.media.filter(item => item.lang === 'all')
    },
    backendMediaCategories (state) {
      return state.mediaCategories
    },
    backendMedia (state) {
      return state.media
    },
    selectMediaCategory (state) {
      const data = state.mediaCategories
        .filter(item => item.lang === 'all' && item.isHidden === false)
        .map(item => ({ id: item.id, name: item.name }))
      return data
    },
    selectMediaCategoryFilterWithoutPage (state) {
      const data = state.mediaCategories
        .filter(item => item.lang === 'all')
        .map(item => ({ id: item.id, name: item.name }))
      return data
    },
    selectMediaCategoryFilter (state) {
      const data = state.mediaCategories
        .map(item => ({ id: item.id, name: item.name }))
      return data
    },
    showMediaCategory: (state) => (id) => {
      const data = state.mediaCategories
        .find(item => item.id === id)
      if (!data) {
        return 'Category Not Found!'
      }
      return data.name
    },
    getMediaId: (state) => (path) => {
      const data = state.media.find(item => item.filePath === path)
      if (!data) {
        return 0
      }
      return data.id
    },
    // return customer
    getCustomers (state) {
      const data = state.media.filter(item => item.categoryId === 2013 && item.isHidden === false)
        .map(item => ({ id: item.id, path: item.filePath, link: item.link })).reverse()
      return data
    },
    // return training devide
    getTrainingDevides (state) {
      const data = state.media.filter(item => item.categoryId === 2014 && item.isHidden === false)
        .map(item => ({ id: item.id, name: item.fileName, enName: item.enFileName, link: item.link, path: item.filePath })).reverse()
      return data
    },
    // return classroom
    getClassroom (state) {
      const data = state.media.filter(item => item.categoryId === 2015 && item.isHidden === false)
        .map(item => ({ id: item.id, name: item.fileName, enName: item.enFileName, link: item.link, path: item.filePath })).reverse()
      return data
    },
    // return slider
    getSlider (state) {
      const data = state.media.filter(item => item.categoryId === 10)
        .map(item => ({ id: item.id, path: item.filePath })).reverse()
      return data
    },
    getTopColumnSlider (state) {
      const data = state.media.filter(item => item.categoryId === 2010 && item.isHidden === false)
        .map(item => ({ id: item.id, path: item.filePath })).reverse()
      return data
    },
    getBottomColumnSlider (state) {
      const data = state.media.filter(item => item.categoryId === 2012 && item.isHidden === false)
        .map(item => ({ id: item.id, path: item.filePath }))
      return data
    },
    getBannerByName (state) {
      const data = state.media.find(item => item.id === 3037)
      console.log(data)
      if (!data) {
        return 'Banner Not Found!'
      }
      return data.filePath
    }
  },
  mutations: {
    setMediaCategories (state, payload) {
      state.mediaCategories = payload
    },
    setMedia (state, payload) {
      state.media = payload
    }
  },
  actions: {
    async getMediaCategoriesData (context) {
      // axios.get(context.rootState.API_Url + 'MediaCategories/')
      await context.rootState.authAxios.get('/MediaCategories').then((response) => {
        const responseData = response.data
        context.commit('setMediaCategories', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async postMediaCategories (context, payload) {
      await context.rootState.authAxios.post('/MediaCategories/', {
        name: payload.name,
        isHidden: payload.isHidden,
        createdAt: payload.createdAt,
        updatedAt: payload.updatedAt,
        author: payload.author,
        lang: payload.lang
      })
      // .then(() => {
      //   showSuccess('Add successfully')
      // }).catch((error) => {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      // })
    },
    async updateMediaCategories (context, payload) {
      await context.rootState.authAxios.put(`/MediaCategories/${payload.id}`, {
        name: payload.name,
        isHidden: payload.isHidden,
        createdAt: payload.createdAt,
        updatedAt: payload.updatedAt,
        author: payload.author,
        lang: payload.lang
      })
      // .then(() => {
      //   showSuccess('Update successfully')
      // }).catch((error) => {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      // })
    },
    async deleteMediaCategories (context, payload) {
      await context.rootState.authAxios.delete(`/MediaCategories/${payload}`
      ).then(() => {
        showSuccess('Xóa thành công')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    },
    // Media
    async getMediaData (context) {
      await axios.get(context.rootState.API_Url + 'Media/').then((response) => {
        const responseData = response.data
        context.commit('setMedia', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async getMediaAdminData (context) {
      await context.rootState.authAxios.get('/Media/GetMediaAdmin').then((response) => {
        const responseData = response.data
        context.commit('setMedia', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async postMedia (context, payload) {
      const formData = new FormData()

      if (!payload.fileName) {
        payload.fileName = payload.file.name.split('.').slice(0, -1).join('.')
      }

      for (const key in payload) {
        if (Object.prototype.hasOwnProperty.call(payload, key)) {
          formData.append(key, payload[key])
        }
      }

      await context.rootState.authAxios.post('/Media/Upload/', formData)
      // .then(() => {
      //   showSuccess('Add successfully')
      // }).catch((error) => {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      // })
    },
    async updateMedia (context, payload) {
      const formData = new FormData()
      let isFirst = true

      for (const key in payload) {
        if (Object.prototype.hasOwnProperty.call(payload, key)) {
          if (isFirst) {
            isFirst = false
            continue // Skip the first iteration (id)
          }
          if (payload[key] !== null) { // Check if the payload value is not null
            formData.append(key, payload[key])
          }
        }
      }

      // console.log('0-----------------------0')
      // for (const [key, value] of formData.entries()) {
      //   console.log(`${key}: ${value}`)
      // }
      await context.rootState.authAxios.put(`/Media/Update/${payload.id}`, formData)
      // .then(() => {
      //   showSuccess('Update successfully')
      // }).catch((error) => {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      // })
    },
    async deleteMedia (context, payload) {
      await context.rootState.authAxios.delete(`/Media/${payload}`
      ).then(() => {
        showSuccess('Xóa thành công')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    },
    async postForDetail (context, payload) {
      /* eslint-disable */
      let imageData = null

      const response = await context.rootState.authAxios.post(
        '/Media/Upload/', payload
      ).then((response) => {
        imageData = response.data.filePath
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })

      return imageData
    },
    async updateForDetail (context, payload) {
      /* eslint-disable */
      let imageData = null

      await context.rootState.authAxios.put(
        '/Media/Update/' + payload.get('id'), payload
      ).then((response) => { 
        imageData = response.data.filePath
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })

      return imageData
    }
  }
}
